import { CellContext } from "@tanstack/react-table"
import classNames from "classnames"

import { UITypes } from "types"

import styles from "./index.module.scss"

interface Props {
  cell: CellContext<UITypes.TableBodyRow, UITypes.TableBodyCell>
}

const AdhocStatusCell = ({ cell }: Props) => {
  const value = cell.getValue().value
  const isInstalled = String(value || "").toLowerCase() === "installed"

  return (
    <span className={classNames(styles.status, { [styles.installed]: isInstalled })}>
      {String(value || "").toUpperCase()}
    </span>
  )
}

export default AdhocStatusCell
